import _ from 'lodash';
import React from 'react';
import postal from 'postal';
import toastr from 'toastr';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import triggerPush from '../../../services/lwadmin/bigquery/big-query-service';

const items = {
  users: 'users',
  wires: 'wires',
  'statistic-events': 'statistic-events',
};

export default function BigqueryManagement() {
  const [triggered, setTriggered] = React.useState(_.mapValues(items, () => false));

  const triggerFunctions = _.mapValues(items, v => () => {
    const type = v.replace('-', ' ');
    const alertText = `You have already triggered pushing all ${type}. Don't do it again! Be patient. Ceiling cat knows all.`;
    const confirmText = `Are you sure you want to push all of the ${type} to BigQuery? It could take some time.`;
    if (triggered[v]) {
      // eslint-disable-next-line no-alert
      alert(alertText);
      return;
    }

    setTriggered({ ...triggered, [v]: true });

    // eslint-disable-next-line no-alert
    if (!window.confirm(confirmText)) return;

    triggerPush(v)
      .then(() => toastr.success(`Pushing all ${type} has been triggered`))
      .catch(e => {
        defaultOnErrorHandler(e, `Error triggering pushing all ${type}`);
        setTriggered({ ...triggered, [v]: false });
      });
  });

  const triggerFullPush = () => {
    _.each(items, v => triggerFunctions[v]());
  };

  useChangeAwareEffect(({ isMount }) => {
    if (!isMount) {
      return;
    }
    postal.subscribe({
      channel: 'lwadmin.bigquery.commands',
      topic: 'trigger-full-push',
      callback: triggerFullPush,
    });

    _.each(items, v => {
      postal.subscribe({
        channel: 'lwadmin.bigquery.commands',
        topic: `trigger-push-${v}`,
        callback: triggerFunctions[v],
      });
    });
  }, {});

  return (
    <p>
      Nothing much to see here. If you have any ideas let the product and development teams know!
    </p>
  );
}
